import * as React from 'react';
import { Create, TextInput, SimpleForm, required } from 'react-admin';
import { validateNotEmpty } from '../../common/VideoPlayer/util';


const VideoSubjectCreate = () => (
    <Create redirect={'/video-subjects'}>
        <SimpleForm>
            <TextInput
                source="name"
                fullWidth
                validate={[required(), validateNotEmpty]}
            />
        </SimpleForm>
    </Create>
);

export default VideoSubjectCreate;
